<template>
  <div>
    <div class="mb-2">
      <button @click="showMode = true"
              v-if="isDentalClinic && !showMode"
              class="btn-themed btn-themed-outline btn-themed-squared-rounder btn-xs">
        {{ showMode ? $t('hide2') : $t('add_tooth_jaw') }}
      </button>
    </div>

    <Transition :css="false"
                @enter="onFormulaEnter"
                @leave="onFormulaLeave">
      <PatientFormula mode="select"
                      :disabled="readonly"
                      v-show="showMode"
                      @input="patientFormulaPressed">
        <template #left-header>
          <button @click="showMode = false"
                  v-if="isDentalClinic && showMode"
                  class="btn-themed btn-themed-outline btn-themed-squared-rounder btn-xs">
            {{ $t('hide2') }}
          </button>
        </template>
      </PatientFormula>
    </Transition>
  </div>
</template>

<script setup>
import PatientFormula from "@/components/pages/patients/PatientFormula"
import {computed, getCurrentInstance, onBeforeMount, ref} from "vue"
import { useStore } from "vuex"
import {onElementHideCollapse, onElementShowExpand} from "@/services/animation.service"

const store = useStore()
const { proxy } = getCurrentInstance()

defineProps({
  readonly: {
    type: Boolean,
    default: false,
  }
})

let i18n = null
let noty = null

const showMode = ref(false)

const isDentalClinic = computed(() => store.getters.isDentalClinic)
const recordTeeth = computed(() => store.getters.recordTeeth)
const usedTeeth = computed(() => store.getters.getVisitTeethWithServicesOrDiagnoses)

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const patientFormulaPressed = async (v) => {
  v = v.toString()
  if(recordTeeth.value.includes(v) && usedTeeth.value.includes(v)) {
    if(!confirm(proxy.$t('together_with_tooth_all_the_related_services_and_materials_will_be_deleted'))) return
  }
  if(store.getters.toothHasLabServices(v)) {
    noty.error(i18n.t('cannot_change_services_that_already_have_laboratory_services_attached'))
    return
  }
  await store.dispatch('toggleRecordTeeth', v)
}

const onFormulaEnter = (el, done) => {
  onElementShowExpand(el, done)
}

const onFormulaLeave = (el, done) => {
  onElementHideCollapse(el, done)
}
</script>
